import { all, fork, put, takeLatest } from 'redux-saga/effects';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import {
  CreateAutomationForSourceActionPayload,
  ToggleEnabledStateForAutomationByIdPayload,
  UpdateAllAutomationsPayload,
  UpdateAutomationById,
  toggleEnabledStateForAutomationByIdAction,
  updateAllAutomationAction,
  updateAutomationByIdAction,
  createAutomationForSourceAction,
} from '../actions';
import {
  createAutomationForSource,
  toggleEnabledStateForAutomationById,
  updateAllAutomations,
  updateAutomationById,
} from '../slices';

export function* updateAllAutomationsSaga(
  action: StoreActionProps<UpdateAllAutomationsPayload>,
) {
  try {
    yield put(
      updateAllAutomations({ automations: action.payload.automations }),
    );
  } catch (error) {
    logger.error('Error in updating all automations saga,', { error });
  }
}

export function* watchUpdateAllAutomationsSaga(): Generator {
  yield takeLatest(updateAllAutomationAction.type, updateAllAutomationsSaga);
}

export function* updateAutomationByIdSaga(
  action: StoreActionProps<UpdateAutomationById>,
) {
  try {
    yield put(updateAutomationById({ ...action.payload }));
  } catch (error) {
    logger.error('Error in updating automations by id saga,', { error });
  }
}

export function* watchUpdateAutomationByIdSaga(): Generator {
  yield takeLatest(updateAutomationByIdAction.type, updateAutomationByIdSaga);
}

export function* toggleEnabledStateForAutomationByIdSaga(
  action: StoreActionProps<ToggleEnabledStateForAutomationByIdPayload>,
) {
  try {
    yield put(toggleEnabledStateForAutomationById({ ...action.payload }));
  } catch (error) {
    logger.error('Error in toggling enabled for automations by id saga,', {
      error,
    });
  }
}

export function* watchToggleEnabledStateForAutomationById(): Generator {
  yield takeLatest(
    toggleEnabledStateForAutomationByIdAction.type,
    toggleEnabledStateForAutomationByIdSaga,
  );
}

function* createAutomationForSourceSaga(
  action: StoreActionProps<CreateAutomationForSourceActionPayload>,
): Generator {
  try {
    yield put(createAutomationForSource(action.payload));
  } catch (error) {
    logger.error(
      `Error in creating automation for source ${action.payload.source} of id ${action.payload.sourceId}`,
      { error },
    );
  }
}

export function* watchCreateAutomationForSourceSaga(): Generator {
  yield takeLatest(
    createAutomationForSourceAction.type,
    createAutomationForSourceSaga,
  );
}

export function* watchAllAutomationsSaga(): Generator {
  yield all([
    fork(watchUpdateAutomationByIdSaga),
    fork(watchUpdateAllAutomationsSaga),
    fork(watchToggleEnabledStateForAutomationById),
    fork(watchCreateAutomationForSourceSaga),
  ]);
}
